import { defaultLanguages, type ZudokuConfig } from "zudoku";

const isProd = process.env.ZUDOKU_PUBLIC_ENV === "production";

const normalizeBasePath = (value?: string) => {
  if (!value) {
    return undefined;
  }

  const rawPath = value.startsWith("http") ? new URL(value).pathname : value;
  const basePath = `/${rawPath}`.replace(/\/+/g, "/").replace(/\/$/, "");

  return basePath || undefined;
};

const basePath = isProd
  ? undefined
  : normalizeBasePath(process.env.ZUDOKU_PUBLIC_BASE_PATH);

const apiOptions = {
  showInfoPage: true,
  schemaDownload: { enabled: true },
  disableSecurity: false,
  expandAllTags: false,
};

const apis: ZudokuConfig["apis"] = isProd
  ? [
      {
        type: "file",
        input: "../idp-api/src/main/openapi/api-client-prod.yaml",
        path: "/api",
        options: apiOptions,
      },
    ]
  : [
      {
        type: "file",
        input: "../idp-api/src/main/openapi/api-main.yaml",
        path: "/api",
        options: apiOptions,
      },
      {
        type: "file",
        input: "../idp-api/src/main/openapi/api-client.yaml",
        path: "/api-client",
        options: apiOptions,
      },
    ];

const navigation: ZudokuConfig["navigation"] = isProd
  ? [
      {
        type: "doc",
        file: "introduction",
        label: "Introduction",
        icon: "book-open",
      },
      {
        type: "link",
        to: "/api",
        label: "API",
        icon: "code",
      },
    ]
  : [
      {
        type: "doc",
        file: "introduction",
        label: "Introduction",
        icon: "book-open",
      },
      {
        type: "link",
        to: "/api",
        label: "Full API",
        icon: "code",
      },
      {
        type: "link",
        to: "/api-client",
        label: "Client API",
        icon: "code",
      },
    ];

const config: ZudokuConfig = {
  syntaxHighlighting: {
    themes: {
      light: "github-light",
      dark: "github-dark",
    },
    languages: [...defaultLanguages, "php"],
  },
  site: {
    logo: {
      src: { light: "/logo-light.svg", dark: "/logo-dark.svg" },
      alt: "mindox",
      href: "/introduction",
      width: "130px",
    },
    showPoweredBy: false,
    title: "mindox API Docs",
    footer: {
      copyright: "mindox API docs by AND Solutions",
    },
  },
  metadata: {
    title: "mindox Platform API",
    description:
      "API reference for the mindox Identity and Document Processing Platform",
  },
  navigation,
  redirects: [{ from: "/", to: "/introduction" }],
  basePath,
  apis,
};

export default config;
